import { render, staticRenderFns } from "./DiscoveryProcessStep3.vue?vue&type=template&id=e6a986f8&scoped=true&"
import script from "./DiscoveryProcessStep3.vue?vue&type=script&lang=js&"
export * from "./DiscoveryProcessStep3.vue?vue&type=script&lang=js&"
import style0 from "./DiscoveryProcessStep3.vue?vue&type=style&index=0&id=e6a986f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6a986f8",
  null
  
)

export default component.exports